import { render, staticRenderFns } from "./InformacoesManutencao.vue?vue&type=template&id=a867a61e&scoped=true&"
import script from "./InformacoesManutencao.vue?vue&type=script&lang=js&"
export * from "./InformacoesManutencao.vue?vue&type=script&lang=js&"
import style0 from "./InformacoesManutencao.vue?vue&type=style&index=0&id=a867a61e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a867a61e",
  null
  
)

export default component.exports